// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.



export const environment: any = {
  version: '3.4.3',
  // buildVersion: '05022025.101000',
  // buildVersion: 'Build: 20250404.165435',

  //test
  // production: false,
  // apiUrl: "https://testadminapi.groupbenefitz.aitestpro.com",
  // url: "https://testadminapi.groupbenefitz.aitestpro.com/api/ap",
  // corporateClientId: "0",
  // clientLogoDashBord: 'assets/img/logo.png',
  // loginPageLogo: 'assets/img/logo.png',
  // commonLoginUrl: 'https://testcommon.groupbenefitz.aitestpro.com/',
  // commonLoginApiUrl: 'https://testcommonapi.groupbenefitz.aitestpro.com/api/cr/',
  // link: 'https://testcommon.groupbenefitz.aitestpro.com/',
  // reportApiUrl: 'https://reportsapi.aitestpro.com',
  // signupFormEnv: 'https://testapi.groupbenefitz.aitestpro.com',
  // fileSize: sessionStorage.getItem("fileSize"),
  // langApi: 'https://languageengineapi.aitestpro.com',
  // authorizePortal: 'https://igbmspaymentstest.aitestpro.com/',
  // authorizeNet: true, // make it to true after setup for new apis subscription and registration have handled


  // Sandbox:
  // apiUrl:"https://api-admin.groupbenefitz.org",
  // corporateClientId:"0",
  // clientLogoDashBord: 'assets/img/logo.png',
  // loginPageLogo:'assets/img/logo.png',

  //prod
  production: true,
  apiUrl: "https://api-admin.groupbenefitz.net",
  url: "https://api-admin.groupbenefitz.net/api/ap",
  corporateClientId: "0",
  clientLogoDashBord: 'assets/img/logo.png',
  loginPageLogo: 'assets/img/logo.png',
  commonLoginUrl: 'https://testcommon.groupbenefitz.aitestpro.com/',
  commonLoginApiUrl: 'https://api-common.groupbenefitz.net/api/cr/',
  link: 'https://testcommon.groupbenefitz.aitestpro.com/',
  reportApiUrl: 'https://reportsapi.groupbenefitz.net',
  signupFormEnv: 'https://api.groupbenefitz.ca',
  fileSize: sessionStorage.getItem("fileSize"),
  langApi: 'https://languageengineapi.groupbenefitz.net',
  authorizePortal: 'https://igbmspayments.aitestpro.com/',
  authorizeNet: true, // make it to true after setup for new apis subscription and registration have handled

  //IBBMS
  // production: false,
  // apiUrl: "https://adminapi.igbms.com",
  // corporateClientId: "0",
  // clientLogoDashBord: '../../../assets/img/iGBMS-dashboad.png',
  // loginPageLogo: '../../../assets/img/ibms.png',
  // commonLoginUrl: 'https://testcommon.groupbenefitz.aitestpro.com/',
  // commonLoginApiUrl: 'https://testcommonapi.groupbenefitz.aitestpro.com/api/cr/',
  // link: 'https://testcommon.groupbenefitz.aitestpro.com/',
  // reportApiUrl: 'https://reportsapi.aitestpro.com',
  // langApi: 'https://languageengineapi.groupbenefitz.net',



  api: "https://testadminapi.groupbenefitz.aitestpro.com",

  app: {
    grp: "https://testapi.groupbenefitz.aitestpro.com/",
    formLink: "testausu"
  },
};





//******************************************************************** */
// let site='PRODUCTION';
// let site='TEST';
// let site='IGBMS';
// // let site='SANDBOX'
// export let environment;
// if(site=='TEST'){
//    environment = {
//     production: false,
//     apiUrl: "https://testadminapi.groupbenefitz.aitestpro.com",
//     corporateClientId:"0",
//     clientLogoDashBord: 'assets/img/logo.png',
//     loginPageLogo:'assets/img/logo.png',



//     api: "https://testadminapi.groupbenefitz.aitestpro.com",

//     app:{
//       grp:"https://testapi.groupbenefitz.aitestpro.com/",
//       formLink:"testausu"
//     },
//   };
// }else if(site=='PRODUCTION'){
//   environment = {
//     production: false,
//       apiUrl:"https://api-admin.groupbenefitz.net",
//       corporateClientId:"0",
//       clientLogoDashBord: 'assets/img/logo.png',
//       loginPageLogo:'assets/img/logo.png',

//     api: "https://testadminapi.groupbenefitz.aitestpro.com",

//     app:{
//       grp:"https://testapi.groupbenefitz.aitestpro.com/",
//       formLink:"testausu"
//     },
//   };
// } else if(site=='IGBMS'){
//   environment = {
//     production: false,
//     apiUrl: "https://adminapi.igbms.com",
//     corporateClientId:"0",
//     clientLogoDashBord: '../../../assets/img/iGBMS-dashboad.png',
//     loginPageLogo:'../../../assets/img/ibms.png',

//     api: "https://testadminapi.groupbenefitz.aitestpro.com",

//     app:{
//       grp:"https://testapi.groupbenefitz.aitestpro.com/",
//       formLink:"testausu"
//     },
//     // corporateClientId:"0"




//   };
// }else if(site=='SANDBOX'){
//   environment = {
//     production: false,
//     apiUrl:"https://api-admin.groupbenefitz.org",
//     corporateClientId:"0",

//     clientLogoDashBord: 'assets/img/logo.png',
//       loginPageLogo:'assets/img/logo.png',

//     api: "https://testadminapi.groupbenefitz.aitestpro.com",

//     app:{
//       grp:"https://testapi.groupbenefitz.aitestpro.com/",
//       formLink:"testausu"
//     },
//   };
// }




/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
